import React from 'react';
import { Tooltip } from '@blueprintjs/core';
import { useIsTruncated } from '../../../hooks/useIsTruncated';
import styles from './DataSyncList.module.sass';

interface DataSyncNameCellProps {
  name: string;
  onClick: () => void;
}

/**
 * Sync name link in the Sync Manager list. Long names are clipped with an ellipsis,
 * so the full name is surfaced in a tooltip — but only when it is actually truncated.
 */
const DataSyncNameCell: React.FC<DataSyncNameCellProps> = ({ name, onClick }) => {
  const [nameRef, isTruncated] = useIsTruncated<HTMLButtonElement>(name);

  return (
    <Tooltip
      content={name}
      disabled={!isTruncated}
      hoverOpenDelay={120}
      placement="top-start"
      fill={true}
      popoverClassName={styles.namePopover}
    >
      <button
        type="button"
        ref={nameRef}
        className={styles.nameLink}
        onClick={onClick}
      >
        {name}
      </button>
    </Tooltip>
  );
};

export default DataSyncNameCell;
